import { render } from "./Locales.vue?vue&type=template&id=824dfc3c"
import script from "./Locales.vue?vue&type=script&lang=js"
export * from "./Locales.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__